"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _pageConfigPop = _interopRequireDefault(require("./components/pageConfigPop.vue"));
var _richText = _interopRequireDefault(require("./components/richText.vue"));
var _shopList = _interopRequireDefault(require("./components/shopList.vue"));
var _shopListSetting = _interopRequireDefault(require("./components/shopListSetting.vue"));
var _addModule = _interopRequireDefault(require("./components/addModule.vue"));
var _bannerListPop = _interopRequireDefault(require("./components/bannerListPop.vue"));
var _richPop = _interopRequireDefault(require("./components/richPop.vue"));
var _customPage = require("@/api/customPage");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _banner = _interopRequireDefault(require("../customPage/components/banner.vue"));
var _diamond = _interopRequireDefault(require("../customPage/components/diamond.vue"));
var _freePuzzle = _interopRequireDefault(require("../customPage/components/freePuzzle.vue"));
var _local_topSearch = _interopRequireDefault(require("./components/local_topSearch.vue"));
var _local_goodsList = _interopRequireDefault(require("./components/local_goodsList.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    pageConfigPop: _pageConfigPop.default,
    richText: _richText.default,
    shopList: _shopList.default,
    banner: _banner.default,
    diamond: _diamond.default,
    addModule: _addModule.default,
    richPop: _richPop.default,
    freePuzzle: _freePuzzle.default,
    bannerListPop: _bannerListPop.default,
    shopListSetting: _shopListSetting.default,
    local_topSearch: _local_topSearch.default,
    local_goodsList: _local_goodsList.default
  },
  props: {},
  data: function data() {
    return {
      backgroundConfig: {
        backgroundUrl: '',
        color: '',
        navbarStatus: 1,
        refreshBackgroundColor: ''
      },
      loading: false,
      pageId: '',
      moduleList: [{
        name: 'banner',
        id: '110',
        type: 'big',
        boole: false
      }, {
        name: 'banner',
        id: '111',
        type: 'small',
        boole: false
      }, {
        name: 'diamond',
        id: '111',
        type: 'small',
        boole: false
      }],
      pageColor: '',
      tableData: []
    };
  },
  computed: {},
  created: function created() {
    this.pageId = this.$route.query.id;
    this.findModule();
  },
  mounted: function mounted() {
    this.drageBuff();
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: '/operationManagement/customPage'
      });
    },
    refreshModule: function refreshModule(val) {
      console.log(val);
      this.tableData.map(function (i) {
        if (i.moduleId === val) {
          i.timestamp = new Date().getTime();
        }
      });
    },
    moduleUpdate: function moduleUpdate(val) {
      if (val.componentCode === 'richText') {
        this.$refs.richPop.open({
          name: val.name,
          id: val.moduleId
        });
      } else if (val.componentCode === 'shopList') {
        this.$refs.shopListSetting.open({
          id: val.moduleId
        });
      } else {
        this.$refs.bannerListPop.open({
          name: val.name + '（' + val.remark + '）',
          id: val.moduleId,
          componentSubcode: val.componentSubcode,
          componentCode: val.componentCode
        });
      }
    },
    addModule: function addModule() {
      this.$refs.addModule.open({
        type: 'add',
        title: ''
      });
    },
    del: function del(val) {
      var _this = this;
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteSort)({
          moduleId: val.moduleId
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findModule();
        });
      });
    },
    allChange: function allChange(val, text) {
      var _this2 = this;
      var obj = {
        moduleId: val.moduleId
      };
      obj[text] = val[text];
      console.log(obj);
      this.$confirm('是否确认编辑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.updateStatus)(obj).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this2.findModule();
        });
      }).catch(function () {
        if (val[text] === 1) {
          val[text] = 0;
        } else {
          val[text] = 1;
        }
      });
    },
    saveBgColor: function saveBgColor() {
      this.$refs.pageConfigPop.open(this.backgroundConfig);
    },
    findModule: function findModule() {
      var _this3 = this;
      this.loading = true;
      (0, _customPage.getModuleList)({
        pageId: this.pageId
      }).then(function (res) {
        _this3.loading = false;
        _this3.pageColor = res.data.color;
        if (res.data.customerPageConfig && res.data.customerPageConfig !== null) {
          _this3.backgroundConfig = res.data.customerPageConfig;
        }
        // this.tableData = []
        res.data.pageModuleList.map(function (i) {
          i['boole'] = false;
          i['timestamp'] = new Date().getTime();
        });
        _this3.tableData = res.data.pageModuleList;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    bothMouseOver: function bothMouseOver(val, itemIndex) {
      val.boole = true;
      this.tableData.map(function (i, index) {
        if (itemIndex !== index) {
          i.boole = false;
        }
      });
    },
    bothMouseLeave: function bothMouseLeave() {
      this.tableData.map(function (i) {
        i.boole = false;
      });
    },
    bothClick: function bothClick(val) {
      this.moduleUpdate(val);
    },
    drageBuff: function drageBuff() {
      var _this4 = this;
      var tbody = document.querySelector('.my_table_name .el-table__body-wrapper tbody');
      _sortablejs.default.create(tbody, {
        handle: '.dg_div',
        animation: 150,
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
            oldIndex = _ref.oldIndex;
          console.log(newIndex, oldIndex);
          console.log(_this4.tableData[newIndex].sort, _this4.tableData[oldIndex].moduleId);
          (0, _customPage.updateSort)({
            moduleId: _this4.tableData[oldIndex].moduleId,
            targetSort: _this4.tableData[newIndex].sort
          }).then(function (res) {
            if (res.data) {
              _this4.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
            }
            _this4.$nextTick(function () {
              _this4.tableData = [];
              _this4.findModule();
            });
          });
        }
      });
    }
  }
};